.backdrop {
  position: fixed;
  inset: 0;
  z-index: 60;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(26, 32, 44, 0.5);
  animation: evx-fadeUp 0.2s ease both;
}
.dialog {
  width: 440px;
  padding: 32px 34px;
  background: var(--color-surface);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
}
.title {
  font-weight: 800;
  color: var(--color-text);
  margin-bottom: 10px;
}
.body {
  font-size: 15px;
  color: var(--color-neutral-700);
  line-height: 1.6;
}
.actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 22px;
}
